const SOURCE_RE =
  /\n*Source: Jason Sherrill FY\d{4}-\d{4} Objectives and Key Results PDF, KR \d+\.\d+\.( ([^\n]+))?/;

/**
 * Strip the seed-data source attribution sentence from a KR description.
 * Preserves any trailing context note (e.g., "Target value 50 = ...") as
 * a separate paragraph.
 */
export function stripPdfSourceAttribution(description: string): string {
  const m = SOURCE_RE.exec(description);
  if (!m) return description;
  const trailing = m[2]?.trim();
  const before = description.slice(0, m.index).trimEnd();
  const after = description.slice(m.index + m[0].length).trimStart();
  const tail = [trailing, after].filter(Boolean).join("\n\n");
  return tail ? `${before}\n\n${tail}` : before;
}

const DUE_PREFIX_RE = /^Due \d{4}-\d{2}-\d{2}\s*[—–-]\s*/;

/**
 * Strip the leading "Due YYYY-MM-DD —" prefix from a KR title used in
 * the printable report, where the due column already shows the date.
 */
export function stripDueDatePrefix(title: string): string {
  return title.replace(DUE_PREFIX_RE, "");
}
